export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const NOINDEX = process.env.REACT_APP_NOINDEX === "true";
export const CONTACT_MAIL = "support@novasoft.mu";
export const mailto = (subject) => `mailto:${CONTACT_MAIL}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`;

export const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/sites-internet-maintenance/", label: "Sites internet & maintenance" },
  { to: "/ia-automatisation/", label: "IA & automatisation" },
  { to: "/strategie-ia/", label: "Stratégie IA" },
  { to: "/integrations-api/", label: "Intégrations" },
  { to: "/a-propos/", label: "À propos" },
  { to: "/contact/", label: "Contact" },
];

export const PROJECTS = [
  {
    id: "immo", url: "https://novaimmo.mu/", domain: "novaimmo.mu", tag: "Immobilier · Plateforme", title: "NovaImmo",
    desc: "Plateforme immobilière à l'Île Maurice : présentation des projets, accompagnement et parcours pensé pour transformer une recherche en prise de contact.",
    stack: ["Immobilier", "Parcours client", "Automatisation"],
  },
  {
    id: "hunt", url: "https://www.roghunting.com/", domain: "roghunting.com", tag: "E-commerce · Marque", title: "RoG Hunting",
    desc: "Boutique e-commerce spécialisée : catalogue technique, parcours d'achat, paiement en ligne et expérience pensée pour une clientèle passionnée.",
    stack: ["E-commerce", "Catalogue", "Automatisation"],
  },
  {
    id: "market", url: "https://naturasell.fr/", domain: "naturasell.fr", tag: "Marketplace · Outdoor", title: "NaturaSell",
    desc: "Marketplace outdoor multi-vendeurs réunissant boutiques, annonces et services autour de plusieurs univers de passionnés.",
    stack: ["Marketplace", "Multi-vendeurs", "Workflows"],
  },
];

export const METHOD = [
  { n: "01 · Comprendre", title: "On part du problème", desc: "Vous nous expliquez ce qui prend du temps, ce qui freine les ventes ou ce qui fonctionne mal aujourd'hui." },
  { n: "02 · Montrer", title: "Vous voyez la solution", desc: "Parcours, maquette ou architecture : vous comprenez ce qui sera fait avant de lancer le développement." },
  { n: "03 · Réaliser", title: "On construit le nécessaire", desc: "Nous intégrons, développons et testons par étapes visibles, sans ajouter des fonctions simplement parce qu'elles sont possibles." },
  { n: "04 · Faire évoluer", title: "On met en ligne et on suit", desc: "Mise en production, maintenance si vous la choisissez, puis améliorations selon les besoins réels." },
];
